import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Fragment, useContext } from "react";
import styles from "./styles.module.scss";

export function Success() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "success" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <Icon image="check-circle" size={40} color="#49be25" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description}>{modal.data.description}</div>
            <div className={styles.footer}>
              <div className={styles.buttons}>
                <button className={styles.cancel} onClick={() => setModal("")}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
